import Button from 'core/display/buttons/Button'
import Graphics from 'core/display/Graphics'

export default class GraphicsButton {
  constructor(data) {
    return new Button(data, new Graphics(data))
  }
}
